export const COMPASS_CATALOG = {
  northArrows: {
    name: "Róża Wiatrów",
    items: {
      simpleArrow: {
        id: "compass-simple-arrow",
        name: "Strzałka północy",
        description: "Prosta strzałka wskazująca północ",
        category: "compass",
        dimensions: { width: 50, height: 80, depth: 80 },
        rotation: 0,
        anchor: "center",
        collision: "none",
        placement: "free-standing",
        scalable: true,
        render2D: {
          type: "group",
          fill: "#000000",
          stroke: "#000000",
          strokeWidth: 2,
          elements: [
            // Arrow Head
            { type: "path", path: "M0,-40 L-15,-10 L-5,-10 L-5,40 L5,40 L5,-10 L15,-10 Z", fill: "#000000", stroke: "#000000", strokeWidth: 1 },
            // N letter (Path approximation)
            { type: "path", path: "M-8,-55 L-8,-75 L8,-55 L8,-75", fill: "none", stroke: "#000000", strokeWidth: 3 }
          ]
        },
        thumbnail: "⬆️",
        metadata: { type: "compass", style: "simple" }
      },
      starCompass: {
        id: "compass-star",
        name: "Gwiazda",
        description: "Róża wiatrów w kształcie gwiazdy",
        category: "compass",
        dimensions: { width: 80, height: 80, depth: 80 },
        rotation: 0,
        anchor: "center",
        collision: "none",
        placement: "free-standing",
        scalable: true,
        render2D: {
          type: "group",
          fill: "#000000",
          stroke: "#000000",
          strokeWidth: 1,
          elements: [
            // Star 4 points
            { type: "path", path: "M0,-40 L10,-10 L40,0 L10,10 L0,40 L-10,10 L-40,0 L-10,-10 Z", fill: "#ffffff", stroke: "#000000", strokeWidth: 2 },
             // N letter
            { type: "path", path: "M-5,-50 L-5,-65 L5,-50 L5,-65", fill: "none", stroke: "#000000", strokeWidth: 2 }
          ]
        },
        thumbnail: "⭐",
        metadata: { type: "compass", style: "star" }
      },
      circleCompass: {
        id: "compass-circle",
        name: "Kompas okrągły",
        description: "Okrągła róża wiatrów",
        category: "compass",
        dimensions: { width: 70, height: 70, depth: 70 },
        rotation: 0,
        anchor: "center",
        collision: "none",
        placement: "free-standing",
        scalable: true,
        render2D: {
          type: "group",
          fill: "#000000",
          stroke: "#000000",
          strokeWidth: 1,
          elements: [
            // Circle
            { type: "circle", x: 0, y: 0, radius: 30, fill: "none", stroke: "#000000", strokeWidth: 2 },
            // Cross
            { type: "path", path: "M0,-30 L0,30 M-30,0 L30,0", fill: "none", stroke: "#000000", strokeWidth: 1 },
            // North Triangle
            { type: "path", path: "M0,-30 L-8,-8 L8,-8 Z", fill: "#000000", stroke: "#000000", strokeWidth: 1 },
            // N Letter
            { type: "path", path: "M-4,-38 L-4,-48 L4,-38 L4,-48", fill: "none", stroke: "#000000", strokeWidth: 2 }
          ]
        },
        thumbnail: "🧭",
        metadata: { type: "compass", style: "circle" }
      },
      splitArrow: {
        id: "compass-split",
        name: "Strzałka dzielona",
        description: "Nowoczesna strzałka północy",
        category: "compass",
        dimensions: { width: 60, height: 90, depth: 90 },
        rotation: 0,
        anchor: "center",
        collision: "none",
        placement: "free-standing",
        scalable: true,
        render2D: {
          type: "group",
          fill: "#ffffff",
          stroke: "#000000",
          strokeWidth: 2,
          elements: [
             // Right half (Filled)
             { type: "path", path: "M0,-40 L20,40 L0,30 Z", fill: "#000000", stroke: "#000000", strokeWidth: 1 },
             // Left half (Outline)
             { type: "path", path: "M0,-40 L-20,40 L0,30 Z", fill: "#ffffff", stroke: "#000000", strokeWidth: 1 },
             // N Letter
             { type: "path", path: "M-6,-50 L-6,-65 L6,-50 L6,-65", fill: "none", stroke: "#000000", strokeWidth: 2 }
          ]
        },
        thumbnail: "nav",
        metadata: { type: "compass", style: "split" }
      },
      minimalCompass: {
        id: "compass-minimal",
        name: "Minimalistyczny",
        description: "Prosty wskaźnik północy",
        category: "compass",
        dimensions: { width: 40, height: 100, depth: 100 },
        rotation: 0,
        anchor: "center",
        collision: "none",
        placement: "free-standing",
        scalable: true,
        render2D: {
          type: "group",
          fill: "#000000",
          stroke: "#000000",
          strokeWidth: 2,
          elements: [
            // Long line
            { type: "path", path: "M0,-40 L0,40", stroke: "#000000", strokeWidth: 1 },
            // North mark
            { type: "path", path: "M0,-40 L-10,-10 L10,-10 Z", fill: "#000000", stroke: "#000000", strokeWidth: 1 },
             // N Letter
             { type: "path", path: "M-5,-55 L-5,-68 L5,-55 L5,-68", fill: "none", stroke: "#000000", strokeWidth: 2 }
          ]
        },
        thumbnail: "⬆",
        metadata: { type: "compass", style: "minimal" }
      }
    }
  }
};

export const getAllCompassItems = () => {
  const allItems = [];
  Object.values(COMPASS_CATALOG).forEach(category => {
    Object.values(category.items).forEach(item => {
      allItems.push(item);
    });
  });
  return allItems;
};

export const getCompassItemById = (id) => {
  const allItems = getAllCompassItems();
  return allItems.find(item => item.id === id);
};